export const PERSONALIZATION_ENGINE = {
  GET_ALL_DEV: 'game-transaction/v1/get-personalization-engine-report',
  GET_ALL_PROD: 'gateway/game-transaction/getPersonalizationEngineReport',
}

//HERE
// export const PERSONALIZATION_ENGINE = {
//   GET_ALL_DEV: 'crm/game-transaction/getPersonalizationEngineReport',
//   GET_ALL_PROD: 'gateway/game-transaction/getPersonalizationEngineReport',
// }
